import { useContext } from "react";
import { OZContext } from "../contexts/OZContext";
import { downloadFileByURL } from "../pages/admin/OfferLanguageConfiguration/utils";
import { adminService } from "../services/admin-services";

export default function useReportsStatusFileDownload() {
    const { setIsLoaderOpen } = useContext(OZContext);

    const handleDownloadReportFile = async (rowData: any) => {
        try {
            setIsLoaderOpen(true)
            const resp = await adminService({
                urlParams: `api/presigned-url/${rowData.transactionId}`,
                method: 'GET'
            })
            if (resp && resp?.file_urls && Array.isArray(resp.file_urls) && resp.file_urls.length > 0) {
                downloadFileByURL(resp.file_urls[0], rowData?.reportName)
            }
            if (resp?.failed_file_url) {
                downloadFileByURL(resp.failed_file_url, rowData?.reportName + '_failed_file')
            }
        } catch (e) {
            console.error(e)
        } finally {
            setIsLoaderOpen(false);
        }
    }

    return { handleDownloadReportFile }
}
